<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    entity: { type: Object, required: true },
    e2eData: { type: String, required: false },
  },

  computed: {
    entityUrl() {
      return `/#/societes/${this.entity.id}-${encodeURIComponent(this.entity.name)}`
    },
    hasAccessToEntity() {
      return (
        roles.includes('ROLE_APP_ADMIN_ENTITY_FULL') && (user.isBusinessMan || roles.includes('ROLE_ACCESS_ENTITY'))
      )
    },
  },
}
</script>
<template>
  <b>
    <a
      v-if="hasAccessToEntity"
      v-html="entity.name"
      :href="entityUrl"
      target="_blank"
      :e2e-data="e2eData"
      :e2e-button="e2eData"
    >
    </a>
    <span v-else :e2e-data="e2eData">
      {{ entity.name }}
    </span>
  </b>
</template>
